/* eslint-disable */

import React from "react";
import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import {
  fetchAuthenticationLogout,
  fetchOrganisationUserGet,
} from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";

import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";

const Breadcrumbs = () => {
  var url = window.location.href;
  var tokens = url.split("/");
  tokens.splice(0, 4);

  if (tokens.length === 0) {
    tokens = ["dashboard"];
  }
  return (
    <div className="flex flex-row text-color-dark-text-tertiary gap-2">
      {tokens.map((token, index) => {
        const crumb = token.charAt(0).toUpperCase() + token.slice(1);

        return (
          <div key={index}>
            {token !== tokens[0] && <div>{">"}</div>}
            <div>{crumb}</div>
          </div>
        );
      })}
    </div>
  );
};

const OrganisationHeader = ({
  organisationSrc,
  organisationName,
  nameLegal,
}) => {
  return (
    <Link
      to={"/cirrus/settings"}
      className={
        "flex flex-col gap-4 items-center justify-center hover:bg-color-dark-background-secondary p-4 rounded-lg transition-all hover:scale-95"
      }
    >
      <OrganisationLogo src={organisationSrc} isLarge={true} />
      <div className="flex flex-col text-center justify-center items-center gap-2">
        <div className="font-bold dark:text-color-dark-text-primary text-color-text-primary text-xl">
          {organisationName}
        </div>
        <div className="text text-color-dark-text-secondary whitespace-nowrap">
          {nameLegal}
        </div>
        <h4 className=" text-color-dark-text-secondary border-2 border-color-dark-border-secondary py-1 px-4 rounded-full">
          BETA
        </h4>
      </div>
    </Link>
  );
};

const SidebarHeader = ({ text }) => {
  return (
    <div className="px-4 pt-2 font-semibold text-xs text-color-text-secondary">
      {text}
    </div>
  );
};

const CirrusSidebar = ({ onCirrusLogout, currentOrganisationUser }) => {
  const background =
    "dark:bg-color-dark-background-secondary bg-color-background-secondary";

  const border =
    "border-r border-color-border-primary dark:border-color-dark-border-primary";
  return (
    <div
      className={`flex flex-col h-full w-full max-w-[250px] p-2   ${background} ${border}
    `}
    >
      <div className="flex flex-col gap-4 py-4">
        <OrganisationHeader
          organisationSrc={
            currentOrganisationUser.organisation.presigned_url_logo
          }
          organisationName={currentOrganisationUser.organisation.name}
          nameLegal={currentOrganisationUser.name_legal}
        />

        <RaindropDivider />
        <SidebarHeader text="GENERAL" />
        <RaindropButton
          title="Dashboard"
          to="/cirrus"
          style={ButtonStyle.Secondary}
          icon="fa-home"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropButton
          title="Donations"
          to="/cirrus/donations"
          style={ButtonStyle.Secondary}
          icon="fa-hand-holding-droplet"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropDivider />
        <SidebarHeader text={"ENGAGEMENT"} />
        <RaindropButton
          title="Description"
          to="/cirrus/description"
          style={ButtonStyle.Secondary}
          icon="fa-star"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropButton
          title="Advertisements"
          to="/cirrus/advertisements"
          style={ButtonStyle.Secondary}
          icon="fa-rectangle-ad"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropButton
          title="Activity"
          to="/cirrus/activity"
          style={ButtonStyle.Secondary}
          icon="fa-clock"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropDivider />
        <SidebarHeader text={"SUPPORT"} />
        <RaindropButton
          title="Feedback"
          to="/cirrus/feedback"
          style={ButtonStyle.Secondary}
          icon="fa-comment"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropButton
          title="Settings"
          to="/cirrus/settings"
          style={ButtonStyle.Secondary}
          icon="fa-cog"
          isFluid={true}
          isLeftAligned={true}
        />
        <RaindropButton
          title="Logout"
          onClick={onCirrusLogout}
          style={ButtonStyle.Secondary}
          icon="fa-sign-out-alt"
          isFluid={true}
          isLeftAligned={true}
        />
      </div>

      {/* <Spacer /> */}
      {/* <div className="flex w-full items-center justify-center pb-6">
        <SVGRaindropLogoWithTitle className="w-full h-4 fill-color-text-tertiary" />
      </div> */}
    </div>
  );
};

const CirrusBaseAuthenticated = ({
  currentOrganisationUser,
  setCurrentOrganisationUser,
}) => {
  const navigate = useNavigate();

  // Gather current account details
  useEffect(() => {
    // If user is already authenticated, do nothing
    if (currentOrganisationUser) {
      console.log("RD-5325", currentOrganisationUser);
    } else {
      // Fetch SupportUser data
      fetchOrganisationUserGet({ organisationUserId: "current" })
        .then((user) => {
          setCurrentOrganisationUser(user);
        })
        .catch(() => {
          navigate("/cirrus/login");
        });
    }
  }, []);

  if (currentOrganisationUser == null) {
    return <RaindropLoadingElement />;
  }

  const onCirrusLogout = () => {
    fetchAuthenticationLogout({ application: "cirrus" }).then(() => {
      setCurrentOrganisationUser(null);
      navigate("cirrus/entry");
    });
  };

  if (window.location.pathname === "/cirrus/register-organisation") {
    return <Outlet />;
  }

  if (currentOrganisationUser?.organisation == null) {
    return <Navigate to="/cirrus/register-organisation" />;
  }

  return (
    <div className="flex flex-col w-full h-full dark:text-color-dark-text-primary text-color-text-primary">
      <div className="flex flex-row h-full overflow-auto">
        <CirrusSidebar
          onCirrusLogout={onCirrusLogout}
          currentOrganisationUser={currentOrganisationUser}
        />
        <div className="flex flex-col h-full w-full overflow-auto px-6 dark:bg-color-dark-background-primary bg-color-background-primary pt-6 gap-6">
          <Breadcrumbs />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CirrusBaseAuthenticated;
